import { isUndefined, isNull } from "lodash";
import getListBrands from "../helpers/getListBrands";
import getListCountries from "../helpers/getListCountries";
import getListDivisions from "../helpers/getListDivisions";

const getAvailableOptions = (currentFilters, data, availableOptions) => {
  // if (!isNull(currentFilters)) {
  //   let reduceCountries = data.countries;
  //
  //   let lastSelected = Object.keys(currentFilters);
  //   lastSelected = lastSelected[lastSelected.length - 1];
  //
  //   if (!isUndefined(currentFilters.divisions)) {
  //     reduceCountries = reduceCountries.filter(
  //       item => item.division === currentFilters.divisions
  //     );
  //   }
  //
  //   if (
  //     !isUndefined(currentFilters.countries) &&
  //     lastSelected !== "countries"
  //   ) {
  //     reduceCountries = reduceCountries.filter(
  //       item => item.country === currentFilters.countries
  //     );
  //   }
  //
  //   if (!isUndefined(currentFilters.brands)) {
  //     reduceCountries = reduceCountries.filter(
  //       item =>
  //         item.brands.filter(brand => brand.niceName === currentFilters.brands)
  //           .length > 0
  //     );
  //   }
  //
  //   return {
  //     divisions: availableOptions.divisions,
  //     countries: getListCountries(reduceCountries),
  //     brands: getListBrands(reduceCountries)
  //   };
  // } else {
    return {
      divisions: getListDivisions(data.countries),
      countries: getListCountries(data.countries),
      brands: getListBrands(data.countries)
    };
  // }
};
export default getAvailableOptions;
